export enum Errors {
  RefExpediteurRequired = 'Aucune référence expéditeur encodée.',
  ExpediteurRequired = 'Aucun expéditeur encodé.',
  ObjetRequired = 'Aucun objet encodé.',
  RemarquesRequired = 'Aucune remarque encodée.',
  DateDocumentRequired = 'Aucune date de document encodée.',
  DateEcheanceRequired = "Aucune date d'échéance encodée.",
  CodeClassementRequired = 'Aucun code de classement sélectionné.',
  DossierClassementRequired = 'Aucun dossier de classement sélectionné.',
  NatureRequired = 'Aucune nature sélectionnée.',
  SourceRequired = 'Aucune source sélectionnée.',
  RefRecommandeRequired = 'Aucune référence recommandé encodée.',
  ProjetRequired = 'Veuillez Sélectionnez le projet.',
  TVAInvalide = "La TVA n'est pas valide.",
  CreationContactAvecTypeContactImpossible = "Création du contact impossible avec ce type de contact, vous n'avez pas le droit.",
  AdresseImpressionCPLocaliteInvalide = "Adresse d'impression code postal/ localité invalide.",
}
